import { render, staticRenderFns } from "./RightImage.vue?vue&type=template&id=afc5d2b8"
import script from "./RightImage.vue?vue&type=script&lang=js"
export * from "./RightImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports